import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import '../css/search-panel.css';

/**
 * Unified search panel component for consistent search UI across pages
 * Supports a unified horizontal layout or a basic grid layout
 */
const SearchPanel = ({ 
  onSearch, 
  onReset, 
  loading = false, 
  children,
  placeholder,
  searchValue,
  onSearchChange,
  statusFilter,
  secondaryFilter,
  extraActions,
  /**
   * true — есть что сбросить (подсвеченный режим);
   * false — только обновление запроса / пустые фильтры (приглушённый серый).
   */
  filtersActive = false,
}) => {
  const { t } = useTranslation();

  // If searchValue is provided, we use the new unified layout
  const isUnified = searchValue !== undefined;

  if (!isUnified) {
    return (
      <div className="search-panel">
        <form onSubmit={onSearch} className="search-form">
          <div className="search-filters">
            {children}
          </div>
          
          <div className="search-actions">
            <button
              type="submit"
              className="search-btn search-btn-primary"
              disabled={loading}
            >
              <span className="btn-text">
                {loading ? t('common.searchLoading') : t('common.search')}
              </span>
            </button>
            
            <button
              type="button"
              onClick={onReset}
              className={`search-btn search-btn-reset ${filtersActive ? 'search-btn-reset--active' : ''}`}
              disabled={loading}
              data-reset-state={filtersActive ? 'filters' : 'idle'}
              aria-label={t('common.reset')}
            >
              <Icon name="x-circle" size={16} />
              <span className="btn-text">{t('common.reset')}</span>
            </button>
          </div>
        </form>
      </div>
    );
  }

  return (
    <div className="search-panel">
      <div className="search-form">
        <div className="search-main-row">
          <div className="search-input-wrapper">
            <input
              type="text"
              className="filter-input with-icon"
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder={placeholder || t('common.search')}
            />
            <div className="search-input-icon">
              <Icon name="search" size={18} />
            </div>
          </div>
          
          {secondaryFilter && (
            <div className="search-secondary-filter-wrapper">
              {secondaryFilter}
            </div>
          )}

          {onReset && (
            <button
              type="button"
              className={`search-panel-reset-btn ${filtersActive ? 'search-panel-reset-btn--active' : ''}`}
              onClick={onReset}
              disabled={loading}
              data-reset-state={filtersActive ? 'filters' : 'idle'}
              aria-label={t('common.reset')}
            >
              <Icon name="x-circle" size={16} />
              <span>{t('common.reset')}</span>
            </button>
          )}

          {statusFilter && (
            <div className="search-status-wrapper">
              {statusFilter}
            </div>
          )}

          <div className="search-actions-unified">
            {extraActions}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchPanel;
